import { createPageConfig } from '@tarojs/runtime'
import component from "../../../node_modules/babel-loader/lib/index.js!./index.jsx"
var config = {"navigationBarTitleText":"首页"};


var inst = Page(createPageConfig(component, 'pages/index/index', {}, config || {}))

